import type { FC, ReactNode } from 'react';
import {
    LuSignal, LuWifi, LuBatteryFull, LuChevronLeft, LuVideo, LuPhone,
    LuPlus, LuPaperclip, LuCamera, LuMic,
} from 'react-icons/lu';
import './CelularWhatsApp.css';

interface CelularWhatsAppProps {
    /** O nome que o cliente vê no topo da conversa: o da empresa. */
    nome: string;
    /** A foto do perfil (o logo da empresa). Sem ela, as iniciais. */
    fotoUrl?: string | null;
    /** Coluna estreita (a prévia do modo edição): moldura fina e altura menor. */
    compacto?: boolean;
    /** A conversa — em geral um `TemplateBubble`, que traz o fundo do WhatsApp. */
    children: ReactNode;
}

const iniciais = (nome: string) =>
    nome.trim().split(/\s+/).slice(0, 2).map(p => p[0]?.toUpperCase() ?? '').join('') || '?';

/**
 * Um celular com o WhatsApp aberto na conversa com a empresa: barra de status,
 * topo, a conversa e a barra de digitar. Desenho fechado em
 * docs/propostas/campanhas/template-leitura-e-historico.html (28/10/2026).
 *
 * A tela tem 375px (a largura de um iPhone) e a altura de um: a mensagem
 * encosta embaixo, como numa conversa. Mensagem que não cabe faz o celular
 * crescer em vez de rolar por dentro — os botões do fim são o que o cliente
 * toca, e rolagem os esconderia.
 *
 * Prefixo `tpl-cel-`, dentro do território da tela de Templates.
 */
const CelularWhatsApp: FC<CelularWhatsAppProps> = ({ nome, fotoUrl, compacto = false, children }) => (
    <div className={`tpl-cel ${compacto ? 'is-compacto' : ''}`}>
        <div className="tpl-cel-tela">
            <div className="tpl-cel-status" aria-hidden="true">
                <span>9:41</span>
                <span className="tpl-cel-ilha" />
                <span className="tpl-cel-st-ic">
                    <LuSignal size={14} /><LuWifi size={14} /><LuBatteryFull size={17} />
                </span>
            </div>

            <div className="tpl-cel-topo">
                <LuChevronLeft size={20} className="tpl-cel-azul" aria-hidden="true" />
                <span className="tpl-cel-av" aria-hidden="true">
                    {fotoUrl ? <img src={fotoUrl} alt="" /> : iniciais(nome)}
                </span>
                <span className="tpl-cel-id">
                    <span className="tpl-cel-nome">{nome}</span>
                    <span className="tpl-cel-sub">Conta comercial</span>
                </span>
                <span className="tpl-cel-acoes tpl-cel-azul" aria-hidden="true">
                    <LuVideo size={20} /><LuPhone size={18} />
                </span>
            </div>

            <div className="tpl-cel-chat">{children}</div>

            <div className="tpl-cel-entrada" aria-hidden="true">
                <LuPlus size={20} />
                <span className="tpl-cel-campo"><span>Mensagem</span><LuPaperclip size={16} /></span>
                <LuCamera size={20} />
                <span className="tpl-cel-mic"><LuMic size={16} /></span>
            </div>
            <div className="tpl-cel-home" aria-hidden="true"><i /></div>
        </div>
    </div>
);

export default CelularWhatsApp;
